/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ActiveDeviceResponse,
    ActiveDeviceResponseFromJSON,
    ActiveDeviceResponseToJSON,
    BadRequestErrorResponse,
    BadRequestErrorResponseFromJSON,
    BadRequestErrorResponseToJSON,
    RegisteredDeviceResponse,
    RegisteredDeviceResponseFromJSON,
    RegisteredDeviceResponseToJSON,
} from '../models';

export interface GetNumberActiveDevicesRequest {
    numberOfDays?: number;
}

export interface GetNumberRegisteredDevicesRequest {
    numberOfDays?: number;
}

/**
 * 
 */
export class DashboardApi extends runtime.BaseAPI {

    /**
     * Returns number of active devices per day
     */
    async getNumberActiveDevicesRaw(requestParameters: GetNumberActiveDevicesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ActiveDeviceResponse>>> {
        const queryParameters: any = {};

        if (requestParameters.numberOfDays !== undefined) {
            queryParameters['numberOfDays'] = requestParameters.numberOfDays;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dashboard/activeDevices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ActiveDeviceResponseFromJSON));
    }

    /**
     * Returns number of active devices per day
     */
    async getNumberActiveDevices(requestParameters: GetNumberActiveDevicesRequest = {}, initOverrides?: RequestInit): Promise<Array<ActiveDeviceResponse>> {
        const response = await this.getNumberActiveDevicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns number of registered devices per day
     */
    async getNumberRegisteredDevicesRaw(requestParameters: GetNumberRegisteredDevicesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<RegisteredDeviceResponse>>> {
        const queryParameters: any = {};

        if (requestParameters.numberOfDays !== undefined) {
            queryParameters['numberOfDays'] = requestParameters.numberOfDays;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dashboard/registeredDevices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RegisteredDeviceResponseFromJSON));
    }

    /**
     * Returns number of registered devices per day
     */
    async getNumberRegisteredDevices(requestParameters: GetNumberRegisteredDevicesRequest = {}, initOverrides?: RequestInit): Promise<Array<RegisteredDeviceResponse>> {
        const response = await this.getNumberRegisteredDevicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
